import React, { useState } from 'react'
import { Button, Collapse } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import ArrowDownGraySvg from '../../../assets/icons/ArrowDownGraySvg'
import ArrowUpSvg from '../../../assets/icons/ArrowUpSvg'
import NotificationGreenSvg from '../../../assets/icons/NotificationGreenSvg'
import Empty from '../../../components/Empty/Empty'
import NotificationItem from '../NotificationPage/NotificationItem'

const NotificationsCollapse = ({ selectedTesis, notifications = [] }) => {
  const navigate = useNavigate()
  const [openCollepse, setOpenCollepse] = useState(false)
  const hasNotifications = notifications?.length > 0

  const toggleCollepse = () => setOpenCollepse(!openCollepse)

  const openAllNotifications = () => {
    if (!hasNotifications) return

    navigate('/hobiNotification', {
      state: {
        notificationData: notifications,
        selectedTesis: selectedTesis,
      },
    })
  }

  const buttons = [
    {
      id: 0,
      title: 'Duyurular',
      toggle: toggleCollepse,
      open: openCollepse,
      onClick: openAllNotifications,
    },
  ]

  return buttons?.map((item) => (
    <div key={item.id}>
      <div className='notificationButton' onClick={item.toggle}>
        <div className='notificationButton-text'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <NotificationGreenSvg width='1.3rem' />
            <p style={{ margin: 0, fontWeight: 'normal', fontSize: '16px' }}>{item.title}</p>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '50px',
              backgroundColor: '#fff',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: !item.open ? '.1rem 0 0 0' : '0 0 .1rem 0',
                minWidth: '1.5rem',
                minHeight: '1.5rem',
                fontSize: '11px',
              }}
            >
              {!item.open ? (
                <div
                  style={{
                    backgroundColor: '#F6F6F6',
                    padding: '.3rem .4rem',
                    borderRadius: '50%',
                  }}
                >
                  <ArrowDownGraySvg width='.8rem' />
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: '#F6F6F6',
                    padding: '.3rem .4rem',
                    borderRadius: '50%',
                  }}
                >
                  <ArrowUpSvg width='.8rem' />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='hobiMap'>
        <Collapse isOpen={item.open}>
          <div className='mapDiv'>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'stretch',
                marginTop: '1rem',
                width: '100%',
              }}
            >
              {!hasNotifications ? (
                <Empty compact text='Bu tesis için henüz duyuru bulunmamaktadır.' />
              ) : (
                notifications.slice(0, 2).map((notification, index) => (
                  <NotificationItem
                    key={notification.id}
                    title={notification.baslik}
                    date={notification.created_at}
                    desc={notification.aciklama}
                    detay={false}
                    dividerVisible={index < 1}
                  />
                ))
              )}
              {hasNotifications ? (
                <Button
                  block
                  className='tubitakTamamla'
                  onClick={item.onClick}
                  style={{
                    fontSize: '16px',
                    border: '1px solid #205C42',
                    backgroundColor: '#fff',
                    color: '#205c42',
                    borderRadius: '5px',
                    padding: '.7rem .5rem',
                    margin: '1rem 0 3rem 0',
                  }}
                >
                  Tüm Duyurular
                </Button>
              ) : null}
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  ))
}

export default NotificationsCollapse
